import { Account } from "../../pages/account/account";
import { Cryptor } from "./cryptor";
import { Strings } from "./Strings";

export class Accounts {

  private static readonly ACCOUNT_KEY: string = Cryptor.aesEncrypt('_account_', Cryptor.LOGIN_KEY, Cryptor.LOGIN_IV);
  private static readonly ACCESS_TOKEN_KEY: string = Cryptor.aesEncrypt('_access_token_', Cryptor.LOGIN_KEY, Cryptor.LOGIN_IV);
  private static readonly REFRESH_TOKEN_KEY: string = Cryptor.aesEncrypt('_refrsh_token_', Cryptor.LOGIN_KEY, Cryptor.LOGIN_IV);
  private static readonly TOKEN_ID: string = Cryptor.aesEncrypt('_token_id_', Cryptor.LOGIN_KEY, Cryptor.LOGIN_IV);

  private static _account: Account = null;

  public static getAccount(): Account {
    if (this._account == null) {
      const cookies = document.cookie.split('; ');
      const cookie = cookies.find(c => c.startsWith(`${this.ACCOUNT_KEY}=`));
      const account = cookie ? decodeURIComponent(cookie.split(`${this.ACCOUNT_KEY}=`)[1]) : null;

      if (account == null) return null;

      this._account = new Account(JSON.parse(Cryptor.aesDecrypt(account, Cryptor.LOGIN_KEY, Cryptor.LOGIN_IV)));
    }

    return this._account;
  }

  public static setAccount(account: Account, days: number = 1) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    const encryptedAccount = Cryptor.aesEncrypt(JSON.stringify(account), Cryptor.LOGIN_KEY, Cryptor.LOGIN_IV);
    document.cookie = `${this.ACCOUNT_KEY}=${encryptedAccount}; expires=${expires}; path=/`;
    this._account = account;
  }

  public static get isAdmin(): boolean {
    if (this._account == null) return false;

    return this._account.isAdmin;
  }

  public static get isRoot(): boolean {
    if (this._account == null) return false;

    return this._account.isRoot;
  }

  public static setTokenId(tokenId: string, days: number = 1) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${this.TOKEN_ID}=${tokenId}; expires=${expires}; path=/`;
  }

  public static getTokenId() {
    const cookies = document.cookie.split('; ');
    const cookie = cookies.find(c => c.startsWith(`${this.TOKEN_ID}=`));
    return cookie ? decodeURIComponent(cookie.split(`${this.TOKEN_ID}=`)[1]) : null;
  }

  public static setToken(accessToken: string, days: number = 1) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${this.ACCESS_TOKEN_KEY}=${accessToken}; expires=${expires}; path=/`;
  }

  public static getToken() {
    const cookies = document.cookie.split('; ');
    const cookie = cookies.find(c => c.startsWith(`${this.ACCESS_TOKEN_KEY}=`));
    return cookie ? decodeURIComponent(cookie.split(`${this.ACCESS_TOKEN_KEY}=`)[1]) : null;
  }

  public static setRefreshToken(accessToken: string, days: number = 7) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${this.REFRESH_TOKEN_KEY}=${accessToken}; expires=${expires}; path=/`;
  }

  public static getRefreshToken() {
    const cookies = document.cookie.split('; ');
    const cookie = cookies.find(c => c.startsWith(`${this.REFRESH_TOKEN_KEY}=`));
    return cookie ? decodeURIComponent(cookie.split(`${this.REFRESH_TOKEN_KEY}=`)[1]) : null;
  }

  // // Remove a cookie
  public static clearAll(): void {
    this.setTokenId('', -1);
    this.setToken('', -1);
    this.setRefreshToken('', -1);
    this.setAccount(new Account(), -1);
  }

  public static isLoggedIn(): boolean {

    const cookies = document.cookie.split('; ');
    const cookie = cookies.find(c => c.startsWith(`${this.ACCESS_TOKEN_KEY}=`));
    return cookie ? true : false;
  }

}
